// polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'styles/index.less'
import 'favicon.png'
import 'front-end-core/helpers/scrolling'
import { initTrack } from 'services/AnalyticsService'
import Clipboard from 'clipboard'
import { toast } from 'react-toastify'
import { DOMReady } from 'front-end-core/services/WindowService'
import LayoutWrapper from 'components/LayoutWrapper'
import { LEGISLATION_FOLDERS } from 'constants/feature-flags'
import debug from 'front-end-core/core/debug'
import Router from 'front-end-core/core/Router'
import Login from 'pages/login'
import Account from 'pages/account'
import CurrentAwarenessReview from 'pages/currentawarenessreview'
import Comments from 'pages/comments'
import CurrentAwareness from 'pages/currentawareness'
import CurrentAwarenessArticle from 'pages/currentawarenessarticle'
import Dashboard from 'pages/dashboard'
import Documents from 'pages/documents'
import QAMenu from 'pages/qamenu'
import QAContent from 'pages/qacontent'
import QAReview from 'pages/qareview'
import Search from 'pages/search'
import Static from 'pages/static'
import Legislation from 'pages/legislation'
import LegislationMenu from 'pages/legislationmenu'
import LegislationReview from 'pages/legislationreview'
import LegislationFolders from 'pages/legislationfolders'
import LegislationCategories from 'pages/legislationcategories'
import NotFound from 'pages/notfound'
import PrecedentsAll from 'pages/precedentsall'
import PrecedentsContent from 'pages/precedentscontent'
import PrecedentsReview from 'pages/precedentsreview'
import PrecedentsAutomatedListings from 'pages/precedentsautomatedlistings'
import DocumentsAll from 'pages/documentsall'
import DocumentsContent from 'pages/documentscontent'
import DocumentsReview from 'pages/documentsreview'
import DocumentsAutomatedListings from 'pages/documentsautomatedlistings'
import Related from 'pages/related'
import Share from 'pages/share'
import Utils from 'pages/utils'
import HashRewrite from 'pages/hashrewrite'
import MwOverview from 'pages/mwoverview'
import MwListDeals from 'pages/mwlistdeals'
import MwAnalytics from 'pages/mwanalytics'
import MwDealDetails from 'pages/mwdealdetails'
import MwDealCompare from 'pages/mwdealcompare'
import AolMenu from 'pages/aolmenu'
import UserAdmin from 'pages/useradmin'

const routes = [
  HashRewrite,
  Login,
  Account,
  MwOverview,
  MwAnalytics,
  MwListDeals,
  MwDealDetails,
  MwDealCompare,
  CurrentAwareness,
  CurrentAwarenessArticle,
  CurrentAwarenessReview,
  Comments,
  Documents,
  QAMenu,
  QAContent,
  QAReview,
  Search,
  Static,
  LegislationMenu,
  LegislationReview,
  ...(LEGISLATION_FOLDERS ? [LegislationFolders, LegislationCategories] : []),
  Legislation,
  PrecedentsAll,
  PrecedentsAutomatedListings,
  PrecedentsContent,
  PrecedentsReview,
  DocumentsAll,
  DocumentsContent,
  DocumentsReview,
  DocumentsAutomatedListings,
  Related,
  Share,
  Utils,
  AolMenu,
  UserAdmin,
  Dashboard,
  NotFound
]

// The Router tries to match the routes in the order they appear in the routes array.
const app = new Router({
  routes,
  layout: LayoutWrapper,
  urlMapping: (url) => url.replace(/^\/?secure/ig, 'corporate').replace(/^\/?ms\//ig, '')
})

DOMReady.subscribe(
  () => {
    initTrack(app)
    app.start()
  },
  (err) => debug.log(err.stack)
)

new Clipboard('[data-clipboard-text]') // eslint-disable-line

toast.configure({
  position: 'bottom-right',
  pauseOnFocusLoss: false,
  autoClose: 3000,
  draggable: false,
  closeButton: false,
  toastClassName: 'bg-dark-sea-green-2 white'
})
